import React  from 'react';
// import NextButton from '../nextButton';
import './style.css';
import foxImg from "./images/fox.png";
const PageWithFrauds = ({ onNextLevel, messNext, answer, setAnswer, ad }) => {

return ( 

	<div className="section">
		<div className="container">
			<div className="head">Выбери сообщение</div>
			<div className="last_box">
				<div className="last_box_content">
					<div className="fox_box">
						<img className="fox-img" src={foxImg} loading="lazy" alt=""/>
					</div>
					<div className="sms_box">
						<div className="div-sms"><button 
							onClick={()=> {
								setAnswer('1');
								onNextLevel('1');
							}}
						className="btn_sms _1 w-button"></button></div>
						<div className="div-sms"><button 
							onClick={()=> {
								setAnswer('2');
								onNextLevel('2');
							}}
						className="btn_sms _2 w-button"></button></div>
						<div className="div-sms"><button 
							onClick={()=> {
								setAnswer('3');
								onNextLevel('3');
							}}
				
						className="btn_sms _3 w-button"></button></div>
						<div className="div-sms"><button 
							onClick={()=> {
								setAnswer('4');
								onNextLevel('4');
							}}
						
						className="btn_sms _4 w-button"></button></div>
					</div>
				</div>
				<div className="text-block">Выбери сообщение не от мошенника и нажми на него</div>
			</div>
		</div>
	</div>
  );
}

export default PageWithFrauds;
